import { useBudgetSourceComboGrid } from '@/commons/combobox/budgetSourceComboGrid.js';
import { useCollectionAgencyCombo } from '@/commons/combobox/collectionAgencyComboGrid.js';
import { useBudgetChapterComboGrid } from '@/commons/combobox/budgetChapterComboGrid.js';
import { useBudgetSubKindItemComboGrid } from '@/commons/combobox/budgetSubKindItemComboGrid.js';
import { useBudgetSubKindItemActiveComboGrid } from '@/commons/combobox/budgetSubKindItemActiveComboGrid.js';
import { useBudgetItemComboGrid } from '@/commons/combobox/budgetItemComboGrid.js';
import { useProjectExpenseComboGrid } from '@/commons/combobox/projectExpenseComboGrid';
import { useBudgetDetailItemComboGrid } from '@/commons/combobox/budgetDetailItemComboGrid.js';
import { useBudgetSubItemComboGrid } from '@/commons/combobox/budgetSubItemComboGrid.js';
import { useAccountComboGrid } from '@/commons/combobox/accountComboGrid.js';
import { useAccountCategoryComboGrid } from '@/commons/combobox/accountCategoryComboGrid.js';
import { useProjectComboGrid } from '@/commons/combobox/projectComboGrid.js';
import { useStateTreasuryComboGrid } from '@/commons/combobox/stateTreasuryComboGrid.js';
import { useProjectSubComboGrid } from '@/commons/combobox/projectSubComboGrid.js';
import { useProjectSubKindComboGrid } from '@/commons/combobox/projectSubKindComboGrid.js';
import { useAccountingObjectComboGrid } from '@/commons/combobox/accountingObjectComboGrid.js';
import { useActivityComboGrid } from '@/commons/combobox/activityComboGrid.js';
import { useStatisticComboGrid } from '@/commons/combobox/statisticComboGrid.js';
import { useBankAccountComboGrid } from '@/commons/combobox/bankAccountComboGrid.js';
import { useBudgetKindItemComboGrid } from '@/commons/combobox/budgetKindItemComboGrid.js';
import { useBudgetGroupItemComboGrid } from '@/commons/combobox/budgetGroupItemComboGrid.js';
import { useAccountComboGridv2 } from '@/commons/combobox/accountComboGridv2.js';

import { useTypeOfFundComboGrid } from '@/commons/combobox/typeOfFundComboGrid.js';
import { useBankInfoCategoryComboGrid } from '@/commons/combobox/bankInfoCategoryComboGrid.js';
import { useDepartmentComboGrid } from '@/commons/combobox/departmentComboGrid.js';
import { usePaLayoutTemplateComboGrid } from '@/commons/combobox/paLayoutTemplateComboGrid.js';
import { useInventoryItemComboGrid } from '@/commons/combobox/inventoryItemComboGrid.js';
import { useStockComboGrid } from '@/commons/combobox/stockComboGrid.js';
import { useBankInfoComboGrid } from '@/commons/combobox/bankInfoComboGrid.js';
import { useBankInfoComboMultipleGrid } from '@/commons/combobox/bankInfoComboMultipleGrid.js';
import { usePurchasePurposeComboGrid } from '@/commons/combobox/purchasePurposeComboGrid.js';
import { useBudgetFeesComboGrid } from '@/commons/combobox/budgetFeesComboGrid.js';
import { useBudgetFeesTypeReportComboGrid } from '@/commons/combobox/budgetFeesTypeReportComboGrid.js';
import { useBudgetSubGroupItemComboGrid } from '@/commons/combobox/budgetSubGroupItemComboGrid.js';
import { useBudgetBelongGroupItemComboGrid } from '@/commons/combobox/budgetBelongGroupItemComboGrid.js';
import { useBudgetSubSectionComboGrid } from '@/commons/combobox/budgetSubSectionComboGrid.js';
import { useTaskComboGrid } from '@/commons/combobox/taskComboGrid.js';
import { useBankViewComboGrid } from '@/commons/combobox/bankViewComboGrid.js';
import { useAccountingObjectCategoryComboGrid } from '@/commons/combobox/accountingObjectCategoryComboGrid.js';
import { useFixedAssetCategoryComboGrid } from '@/commons/combobox/fixedAssetCategoryComboGrid.js';
import { useInvoiceFormNumberComboGrid } from '@/commons/combobox/invoiceFormNumberComboGrid.js';
import { useInvoiceFormMEInvoiceComboGrid } from '@/commons/combobox/invoiceFormMEInvoiceComboGrid.js';
import { useVoucherTypeComboGrid } from '@/commons/combobox/voucherTypeComboGrid.js';
import { useFundStructureComboGrid } from '@/commons/combobox/fundStructureComboGrid.js';
import { useBUPlanImportComboGrid } from '@/commons/combobox/buPlanImportComboGrid.js';
import { useBudgetFeesType1ComboGrid } from '@/commons/combobox/budgetFeesType1ComboGrid.js';
import { useBudgetFeesType2ComboGrid } from '@/commons/combobox/budgetFeesType2ComboGrid.js';
import { useInventoryCategoryComboGrid } from '@/commons/combobox/inventoryCategoryComboGrid.js';
import { useAccountStockComboGrid } from '@/commons/combobox/accountStockComboGrid.js';
import { useAccountCostComboGrid } from '@/commons/combobox/accountCostComboGrid.js';
import { useAccountSaleComboGrid } from '@/commons/combobox/accountSaleComboGrid.js';
import { useSalaryScaleComboGrid } from '@/commons/combobox/salaryScaleComboGrid.js';
import { useSalaryComboGrid } from '@/commons/combobox/salaryComboGrid.js';
import { useEmployeeTypeComboGrid } from '@/commons/combobox/employeeTypeComboGrid.js';
import { useTopicComboGrid } from '@/commons/combobox/topicComboGrid.js';
import { useContractComboGrid } from '@/commons/combobox/contractComboGrid.js';
import { useStateBankComboGrid } from '@/commons/combobox/stateBankComboGrid.js';
import { useCommercialBankComboGrid } from '@/commons/combobox/commercialBankComboGrid.js';
import { useAccountCustomComboGrid } from '@/commons/combobox/accountCustomComboGrid.js';
import { usePayrollItemGrid } from '@/commons/combobox/payrollItemComboGrid.js';
import { usePayrollDeductItemGrid } from '@/commons/combobox/payrollDeductItemComboGrid.js';
import { usePayrollRegularItemGrid } from '@/commons/combobox/payrollRegularItemComboGrid.js';
import { useAccountAutoBusinessCustomComboGrid } from '@/commons/combobox/accountCustomAutoBusinessComboGrid.js';
import { useInventoryItemCustomComboGrid } from '@/commons/combobox/inventoryItemCustomComboGrid.js';
import { useBudgetProvideComboGrid } from '@/commons/combobox/budgetProvideComboGrid.js';
import { useToolTypeComboGrid } from '@/commons/combobox/toolTypeComboGrid.js';
import { useCashWithdrawType } from '@/commons/combobox/cashWithdrawType.js';
import { useBudgetSubKindItemComboMultipleGrid } from '@/commons/combobox/budgetSubKindItemComboMultipleGrid.js';
import { useBudgetSourcePropertyComboMultipleGrid } from '@/commons/combobox/budgetSourcePropertyComboMultipleGrid.js';
import { useFixedAssetComboGrid } from '@/commons/combobox/fixedAssetComboGrid.js';
import { useManagerUserComboGrid } from '@/commons/combobox/managerUserComboGrid.js';
import { useDashboardCombo } from '@/commons/combobox/dashboardCombo.js';

/**
 * Khởi tạo action combo
 * @param {*} comboboxDataRemote
 * @param {*} comboboxLoadData
 * @returns
 * NXCHIEN 06.05.2022
 */
export const useInitActionCombo = (comboboxDataRemote, comboboxLoadData) => {
  const { budgetProvideComboConfig, onBudgetProvideComboboxLoadData } = useBudgetProvideComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  const {
    //CB Mã cơ quan thu
    onCollectionAgencyComboboxLoadData,
  } = useCollectionAgencyCombo(comboboxDataRemote, comboboxLoadData);

  //#region khởi tạo config cho combox trong grid
  const {
    //CB Nguồn
    budgetSourceComboConfig,
    onBudgetSourceComboboxLoadData,
    onBudgetSourceComboboxLoadAllData,
    onBudgetSourceComboboxLoadAllActiveData,
  } = useBudgetSourceComboGrid(comboboxDataRemote, comboboxLoadData);
  const {
    //CB Chương
    budgetChapterComboConfig,
    onBudgetChapterComboboxLoadData,
  } = useBudgetChapterComboGrid(comboboxDataRemote, comboboxLoadData);
  const {
    //CB loại khoản
    budgetSubKindItemComboConfig,
    onBudgetSubKindItemComboboxLoadData,
  } = useBudgetSubKindItemComboGrid(comboboxDataRemote, comboboxLoadData);

  const {
    //CB khoản cha. khoản con
    budgetSubKindItemActiveComboConfig,
    onBudgetSubKindItemActiveComboboxLoadData,
  } = useBudgetSubKindItemActiveComboGrid(comboboxDataRemote, comboboxLoadData);

  const {
    //CB loại khoản mutiple
    budgetSubKindItemComboMutipleConfig,
    onBudgetSubKindItemComboboxMutipleLoadData,
  } = useBudgetSubKindItemComboMultipleGrid(comboboxDataRemote, comboboxLoadData);
  // Kinh phí
  const { budgetSourcePropertyComboConfig, onBudgetSourcePropertyComboboxLoadData } =
    useBudgetSourcePropertyComboMultipleGrid(comboboxDataRemote, comboboxLoadData);

  const {
    //CB mục tiểu mục
    budgetItemComboConfig,
    onBudgetItemComboboxLoadData,
  } = useBudgetItemComboGrid(comboboxDataRemote, comboboxLoadData);
  const {
    //CB tiết tiểu mục
    budgetDetailItemComboConfig,
    onBudgetDetailItemComboboxLoadData,
  } = useBudgetDetailItemComboGrid(comboboxDataRemote, comboboxLoadData);
  const { budgetSubItemComboConfig, onBudgetSubItemComboboxLoadData } = useBudgetSubItemComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  //CB tài khoản
  const {
    accountComboConfig,
    onAccountComboboxLoadData,
    accountComboParalellConfig,
    onChildAccountLoadData,
    onAccountComboboxParalellLoadData,
    onAccountComboboxLoadAllData,
    accountComboChildConfig,
  } = useAccountComboGrid(comboboxDataRemote, comboboxLoadData);
  //CB tài khoản có thêm bậc
  const { accountCombov2Config, onAccountComboboxv2LoadData } = useAccountComboGridv2(
    comboboxDataRemote,
    comboboxLoadData,
  );
  const { onAccountCategoryComboboxLoadData } = useAccountCategoryComboGrid(comboboxDataRemote, comboboxLoadData);
  //CB CTMT, Dự án
  const {
    projectComboConfig,
    projectBUPlanImportComboConfig,
    onProjectLoadData,
    onProjectComboboxLoadData,
    onProjectCommonComboboxLoadData,
    projectAllDataInactiveComboConfig,
    onProjectComboboxLoadAllData,
    onProjectComboboxLoadAllDataInactive,
    onTargetProjectComboboxLoadData,
    onTargetAllActiveProjectComboboxLoadData,
  } = useProjectComboGrid(comboboxDataRemote, comboboxLoadData);

  //CB KBNN ghi
  const { onStateTreasuryComboboxLoadData } = useStateTreasuryComboGrid(comboboxDataRemote, comboboxLoadData);
  //CB Dự án
  const { projectSubComboConfig, onProjectSubComboboxLoadData } = useProjectSubComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //CB công trình
  const { projectSubKindComboConfig, onProjectSubKindComboboxLoadData, onProjectSubKindLoadData } =
    useProjectSubKindComboGrid(comboboxDataRemote, comboboxLoadData);

  const {
    //CB cán bộ
    accountingObjectComboConfig,
    accountingObjectEmployeeComboConfig,
    onCustomerComboboxLoadData,
    onAccountingObjectComboboxLoadData,
    accountingObjectComboCreditConfig,
    accountingObjectComboDebitConfig,
  } = useAccountingObjectComboGrid(comboboxDataRemote, comboboxLoadData);
  const {
    //CB hoạt động
    activityComboConfig,
    onActivityComboboxLoadData,
    onActivityComboboxLoadAllData,
  } = useActivityComboGrid(comboboxDataRemote, comboboxLoadData);
  const {
    //CB thống kê
    statisticComboConfig,
    onStatisticComboboxLoadData,
  } = useStatisticComboGrid(comboboxDataRemote, comboboxLoadData);
  const {
    //CB TK ngân hàng
    bankAccountComboConfig,
    onBankAccountComboboxLoadData,
  } = useBankAccountComboGrid(comboboxDataRemote, comboboxLoadData);
  //CB khoản
  const { budgetKindItemComboConfig, onBudgetKindItemComboboxLoadData, onBudgetKindItemComboboxLoadAllData } =
    useBudgetKindItemComboGrid(comboboxDataRemote, comboboxLoadData);

  //CB Nhóm mục chi
  const { groupItemComboConfig, onGroupItemComboboxLoadData } = useBudgetGroupItemComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  //CB Loại quỹ
  const { typeOfFundComboConfig, onTypeOfFundComboboxLoadData } = useTypeOfFundComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  //Loại tài khoản
  const { bankInfoCategoryComboConfig, onBankInfoCategoryComboboxLoadData } = useBankInfoCategoryComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  //Phòng ban
  const {
    departmentComboConfig,
    onDepartmentComboboxLoadData,
    departmentMostDetailComboConfig,
    onDepartmentMostDetailComboboxLoadData,
  } = useDepartmentComboGrid(comboboxDataRemote, comboboxLoadData);

  //layout template phân hệ lương
  const { paLayoutTemplateComboConfig, onPaLayoutTemplateComboboxLoadData } = usePaLayoutTemplateComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  //Vật tư hàng hóa
  const { inventoryItemComboConfig, inventoryItemNotServiceComboConfig, onInventoryItemComboboxLoadData } =
    useInventoryItemComboGrid(comboboxDataRemote, comboboxLoadData);

  //Công cụ dụng cụ
  const { inventoryItemToolComboConfig } = useInventoryItemComboGrid(comboboxDataRemote, comboboxLoadData);

  //Combo kho
  const { stockComboConfig, onStockComboboxLoadData } = useStockComboGrid(comboboxDataRemote, comboboxLoadData);

  // tài khoản
  const { bankInfoComboConfig, bankInfoComboConfig1, bankInfoComboConfig2, onBankInfoComboboxLoadData } =
    useBankInfoComboGrid(comboboxDataRemote, comboboxLoadData);

  // Tài khoản NH, KB Multiple
  const { bankInfoComboMultipleConfig, onBankInfoComboboxMultipleLoadData } = useBankInfoComboMultipleGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //CB nhóm hàng hóa dịch vụ
  const { purchasePurposeComboConfig, onPurchasePurposeComboboxLoadData } = usePurchasePurposeComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //CB phí lệ phí
  const { budgetFeesComboConfig, onBudgetFeesComboboxLoadData } = useBudgetFeesComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  // phi, Lệ phí
  const { budgetFeesReportComboConfig, onBudgetFeesTypeReportComboboxLoadData } = useBudgetFeesTypeReportComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //CB tiểu nhóm mục chi
  const { budgetSubGroupItemComboConfig, onBudgetSubGroupItemComboboxLoadData } = useBudgetSubGroupItemComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //CB tiết tiểu mục
  const { budgetSubSectionComboConfig, onBudgetSubSectionComboboxLoadData } = useBudgetSubSectionComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //CB thuộc nhóm
  const { budgetBelongGroupItemComboConfig, onBudgetBelongGroupItemComboboxLoadData } = useBudgetBelongGroupItemComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //mã - tên ngân hàng
  const { bankViewComboConfig, onBankViewComboboxLoadData } = useBankViewComboGrid(comboboxDataRemote, comboboxLoadData);

  // Nhiệm vụ
  const { TaskComboConfig, onTaskComboboxLoadData, onTaskComboboxLoadDataAllActive } = useTaskComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  //#endregion

  //Loại khách hàng nhà cung cấp
  const { accountingObjectCategoryComboConfig, onAccountingObjectCategoryComboboxLoadData } =
    useAccountingObjectCategoryComboGrid(comboboxDataRemote, comboboxLoadData);

  //Mẫu số hóa đơn
  const { invoiceFormNumberComboConfig, onInvoiceFormNumberComboboxLoadData } = useInvoiceFormNumberComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  const { invoiceFormMEInvoiceComboConfig, onInvoiceFormMEInvoiceComboboxLoadData } = useInvoiceFormMEInvoiceComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //Loại chứng từ
  const { voucherTypeComboConfig, onVoucherTypeComboboxLoadData } = useVoucherTypeComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  //Phòng ban
  const { fundStructureComboConfig, onFundStructureComboboxLoadData } = useFundStructureComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  // Nhập dự toán
  const { bUPlanImportComboConfig, onBUPlanImportComboboxLoadData } = useBUPlanImportComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  // Phí
  const { budgetFeesType1ComboConfig, onBudgetFeesType1ComboboxLoadData } = useBudgetFeesType1ComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  // Lệ phí
  const { budgetFeesType2ComboConfig, onBudgetFeesType2ComboboxLoadData } = useBudgetFeesType2ComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //Loại VT, HH
  const { inventoryCategoryComboConfig, onInventoryCategoryComboboxLoadData } = useInventoryCategoryComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  // Tài khoản kho
  const { accountStockComboConfig, onAccountStockComboboxLoadData } = useAccountStockComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  //TK chi phí
  const { accountCostComboConfig, onAccountCostComboboxLoadData } = useAccountCostComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  // TK doanh thu
  const { accountSaleComboConfig, onAccountSaleComboboxLoadData } = useAccountSaleComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  // Đề tài
  const { topicComboConfig, onTopicComboboxLoadData } = useTopicComboGrid(comboboxDataRemote, comboboxLoadData);
  //#endregion

  // Ngạch lương
  const { salaryScaleComboConfig, onSalaryScaleComboboxLoadData } = useSalaryScaleComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  // Tiền lương
  const {
    salaryComboConfig,
    onSalaryComboboxLoadData,
    onSalaryComboboxLoadDataHasNotSelect,
    onSalagovSalaryTableComboboxLoadData,
  } = useSalaryComboGrid(comboboxDataRemote, comboboxLoadData);

  // Loại cán bộ
  const { employeeTypeComboConfig, onEmployeeTypeComboboxLoadData } = useEmployeeTypeComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  // Hợp đồng
  const { contractComboConfig, onContractComboboxLoadData, onContractComboboxLoadDataAllActive } = useContractComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //Ngân hàng
  const { stateBankComboConfig, onStateBankComboboxLoadData } = useStateBankComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //Ngân hàng thương mại
  const { commercialBankComboConfig, onCommercialBankComboboxLoadData } = useCommercialBankComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //Tài khoản
  const { accountComboMostDetailConfig, onAccountComboboxLoadDataCustom } = useAccountCustomComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  // Khoản lương
  const { payrollItemComboConfig, onPayrollItemComboboxLoadData } = usePayrollItemGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  const { payrollRegularItemComboConfig, onPayrollRegularItemComboboxLoadData } = usePayrollRegularItemGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  const { payrollDeductItemComboConfig, onPayrollDeductItemComboboxLoadData } = usePayrollDeductItemGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //Config tài khoản nợ, tài khoản có cho Định khoản tự động
  const { accountAutoBusinessComboConfig, onAccountAutoBusinessComboboxLoadDataCustom } =
    useAccountAutoBusinessCustomComboGrid(comboboxDataRemote, comboboxLoadData);

  // vật tư
  const { inventoryItemCustomComboConfig, onInventoryItemCustomComboboxLoadData } = useInventoryItemCustomComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );
  // Công cụ dụng cụ
  const { toolTypeComboConfig, onToolTypeComboboxLoadData } = useToolTypeComboGrid(comboboxDataRemote, comboboxLoadData);

  const { cashWithdrawTypeComboConfig, onCashWithdrawType } = useCashWithdrawType(comboboxDataRemote, comboboxLoadData);

  // Loại tài sản cố định
  const {
    fixedAssetCategoryComboConfig,
    fixedAssetCategoryDetailComboConfig,
    onFixedAssetCategoryDetailComboboxLoadData,
    onFixedAssetCategoryComboboxLoadData,
  } = useFixedAssetCategoryComboGrid(comboboxDataRemote, comboboxLoadData);
  // Tài sản cố định, TVDAT 09/12/2022
  const { fixedAssetComboConfig, onFixedAssetComboboxLoadData } = useFixedAssetComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  // Quản lý người dùng
  const { managerUserComboConfig, onManagerUserComboboxLoadData } = useManagerUserComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  // Dashboard 21/06/2022
  const {
    onDashboardComboboxLoadData,
    onDashboardComboboxLoadDataSituation,
    onDashboardComboboxActiveLoadData,
    onDashboardComboboxLoadDataBudgetPlan,
    onDashboardComboboxLoadDataActivity,
  } = useDashboardCombo(comboboxDataRemote, comboboxLoadData);

  const { projectExpenseComboConfig, onProjectExpenseComboboxLoadData } = useProjectExpenseComboGrid(
    comboboxDataRemote,
    comboboxLoadData,
  );

  //#endregion

  return {
    budgetSourceComboConfig,
    onBudgetSourceComboboxLoadData,
    budgetChapterComboConfig,
    onBudgetChapterComboboxLoadData,
    budgetSubKindItemComboConfig,
    onBudgetSubKindItemComboboxLoadData,
    budgetSubKindItemActiveComboConfig,
    onBudgetSubKindItemActiveComboboxLoadData,
    budgetItemComboConfig,
    onBudgetItemComboboxLoadData,
    budgetSubItemComboConfig,
    onBudgetSubItemComboboxLoadData,
    accountComboConfig,
    accountComboParalellConfig,
    onAccountComboboxParalellLoadData,
    onAccountComboboxLoadData,
    onAccountComboboxLoadAllData,
    onAccountCategoryComboboxLoadData,
    projectComboConfig,
    projectBUPlanImportComboConfig,
    onProjectCommonComboboxLoadData,
    onProjectLoadData,
    onProjectComboboxLoadData,
    projectAllDataInactiveComboConfig,
    onProjectComboboxLoadAllDataInactive,
    onTargetProjectComboboxLoadData,
    onProjectComboboxLoadAllData,
    projectSubComboConfig,
    onProjectSubComboboxLoadData,
    projectSubKindComboConfig,
    onProjectSubKindComboboxLoadData,
    onProjectSubKindLoadData,
    accountingObjectComboConfig,
    accountingObjectComboCreditConfig,
    accountingObjectComboDebitConfig,
    onAccountingObjectComboboxLoadData,
    onCustomerComboboxLoadData,
    activityComboConfig,
    onActivityComboboxLoadData,
    onActivityComboboxLoadAllData,
    statisticComboConfig,
    onStatisticComboboxLoadData,
    bankAccountComboConfig,
    onBankAccountComboboxLoadData,
    budgetKindItemComboConfig,
    onBudgetKindItemComboboxLoadData,
    groupItemComboConfig,
    onGroupItemComboboxLoadData,
    typeOfFundComboConfig,
    onTypeOfFundComboboxLoadData,
    bankInfoCategoryComboConfig,
    onBankInfoCategoryComboboxLoadData,
    departmentComboConfig,
    onDepartmentComboboxLoadData,
    inventoryItemComboConfig,
    inventoryItemNotServiceComboConfig,
    inventoryItemToolComboConfig,
    onInventoryItemComboboxLoadData,
    stockComboConfig,
    onStockComboboxLoadData,
    bankInfoComboConfig,
    bankInfoComboConfig1,
    bankInfoComboConfig2,
    onBankInfoComboboxLoadData,
    purchasePurposeComboConfig,
    onPurchasePurposeComboboxLoadData,
    onBankInfoComboboxLoadData,
    budgetFeesComboConfig,
    onBudgetFeesComboboxLoadData,
    budgetSubGroupItemComboConfig,
    onBudgetSubGroupItemComboboxLoadData,
    budgetSubSectionComboConfig,
    onBudgetSubSectionComboboxLoadData,
    onBudgetFeesComboboxLoadData,
    TaskComboConfig,
    onTaskComboboxLoadData,
    onTaskComboboxLoadDataAllActive,
    onBudgetFeesComboboxLoadData,
    bankViewComboConfig,
    onBankViewComboboxLoadData,
    accountingObjectCategoryComboConfig,
    onAccountingObjectCategoryComboboxLoadData,
    invoiceFormNumberComboConfig,
    onInvoiceFormNumberComboboxLoadData,
    invoiceFormMEInvoiceComboConfig,
    onInvoiceFormMEInvoiceComboboxLoadData,
    voucherTypeComboConfig,
    onVoucherTypeComboboxLoadData,
    fundStructureComboConfig,
    onFundStructureComboboxLoadData,
    bUPlanImportComboConfig,
    onBUPlanImportComboboxLoadData,
    budgetFeesType1ComboConfig,
    onBudgetFeesType1ComboboxLoadData,
    budgetFeesType2ComboConfig,
    onBudgetFeesType2ComboboxLoadData,
    inventoryCategoryComboConfig,
    onInventoryCategoryComboboxLoadData,
    accountStockComboConfig,
    onAccountStockComboboxLoadData,
    accountCostComboConfig,
    onAccountCostComboboxLoadData,
    accountSaleComboConfig,
    onAccountSaleComboboxLoadData,
    salaryScaleComboConfig,
    onSalaryScaleComboboxLoadData,
    salaryComboConfig,
    onSalaryComboboxLoadData,
    onSalaryComboboxLoadDataHasNotSelect,
    onSalagovSalaryTableComboboxLoadData,
    employeeTypeComboConfig,
    onEmployeeTypeComboboxLoadData,
    topicComboConfig,
    onTopicComboboxLoadData,
    accountCombov2Config,
    onAccountComboboxv2LoadData,
    contractComboConfig,
    onContractComboboxLoadData,
    onContractComboboxLoadDataAllActive,
    budgetBelongGroupItemComboConfig,
    onBudgetBelongGroupItemComboboxLoadData,
    stateBankComboConfig,
    onStateBankComboboxLoadData,
    onBudgetSourceComboboxLoadAllData,
    onBudgetSourceComboboxLoadAllActiveData,
    accountComboMostDetailConfig,
    onAccountComboboxLoadDataCustom,
    onBudgetKindItemComboboxLoadAllData,
    payrollItemComboConfig,
    onPayrollItemComboboxLoadData,
    payrollRegularItemComboConfig,
    onPayrollRegularItemComboboxLoadData,
    payrollDeductItemComboConfig,
    onPayrollDeductItemComboboxLoadData,
    accountAutoBusinessComboConfig,
    onAccountAutoBusinessComboboxLoadDataCustom,
    inventoryItemCustomComboConfig,
    onInventoryItemCustomComboboxLoadData,
    budgetProvideComboConfig,
    onBudgetProvideComboboxLoadData,
    budgetDetailItemComboConfig,
    onBudgetDetailItemComboboxLoadData,
    onToolTypeComboboxLoadData,
    toolTypeComboConfig,
    cashWithdrawTypeComboConfig,
    onCashWithdrawType,
    budgetSubKindItemComboMutipleConfig,
    onBudgetSubKindItemComboboxMutipleLoadData,
    bankInfoComboMultipleConfig,
    onBankInfoComboboxMultipleLoadData,
    onCollectionAgencyComboboxLoadData,
    accountComboChildConfig,
    onChildAccountLoadData,
    onStateTreasuryComboboxLoadData,
    budgetSourcePropertyComboConfig,
    onBudgetSourcePropertyComboboxLoadData,
    paLayoutTemplateComboConfig,
    onPaLayoutTemplateComboboxLoadData,
    onTargetAllActiveProjectComboboxLoadData,
    fixedAssetCategoryComboConfig,
    fixedAssetCategoryDetailComboConfig,
    onFixedAssetCategoryDetailComboboxLoadData,
    onFixedAssetCategoryComboboxLoadData,
    fixedAssetComboConfig,
    onFixedAssetComboboxLoadData,
    departmentMostDetailComboConfig,
    onDepartmentMostDetailComboboxLoadData,
    onBudgetFeesTypeReportComboboxLoadData,
    accountingObjectEmployeeComboConfig,
    managerUserComboConfig,
    onManagerUserComboboxLoadData,
    onDashboardComboboxLoadData,
    onDashboardComboboxLoadDataSituation,
    onDashboardComboboxActiveLoadData,
    onDashboardComboboxLoadDataBudgetPlan,
    projectExpenseComboConfig,
    onProjectExpenseComboboxLoadData,
    onDashboardComboboxLoadDataActivity,
    commercialBankComboConfig,
    onCommercialBankComboboxLoadData
  };
};
